export var DOCUMENT_TYPE_OPTIONS = [
    { value: '1', label: 'Financial Statements' },
    { value: '2', label: 'Bank Statements' },
    { value: '3', label: 'Tax Returns' },
    { value: '4', label: "Driver's License" },
    { value: '5', label: 'Voided Checks' },
    { value: '6', label: 'Tax Exemption Certificates' },
    { value: '7', label: 'Other' },
    { value: '8', label: 'Invoice/Sales Order' },
    { value: '9', label: 'Signed Documents' },
];
export var ACKNOWLEDGE_CATEGORY = 'Acknowledge';
export var getDocumentTypeCode = function (label) {
    var option = DOCUMENT_TYPE_OPTIONS.find(function (candidate) { return candidate.label === label; });
    return option ? Number(option.value) : undefined;
};
var ASSIGN_DOCUMENT_TYPE_NAMES = {
    '1': 'FINANCIAL_STATEMENTS',
    '2': 'BANK_STATEMENTS',
    '3': 'TAX_RETURNS',
    '4': 'DRIVERS_LICENSE',
    '5': 'VOIDED_CHECKS',
    '6': 'TAX_EXEMPTION_CERTIFICATES',
    '7': 'OTHERS',
    '8': 'INVOICE_SALES_ORDER',
    '9': 'SIGNED_DOCUMENTS',
};
export var getAssignDocumentTypeName = function (code) {
    return code === undefined || code === null || code === '' ? undefined : ASSIGN_DOCUMENT_TYPE_NAMES[String(code)];
};
